import axios from 'axios'
import appConfig from '@/appconfig'
import store from '../store'
import endpoint from '@constants/apipath'

export const actions = {
  init({ state, dispatch }) {
    setDefaultAuthHeaders(state)
  },
  // "fetchFraudPlusDistancereport": "bcr/api/fraudplus/distancereport",
  async fetchFraudPlusDistanceCalculation({ commit }, payload) {
    let url = `${appConfig.apiEndPoint}${endpoint.fraudPlusPath.fetchFraudPlusDistancereport}`
    return axios
      .post(url, payload, {
        headers: setHeaders(),
      })
      .then((response) => {
        return response
      })
      .catch((error) => {
        var errorMsg = error.response
        if (errorMsg !== '') {
          alert(errorMsg)
        } else {
          return error
        }
      })
  },
  async fetchPackagesforUser({ state }, { userId, productId } = {}) {
    return axios
      .get(
        `${appConfig.apiEndPoint}${endpoint.fraudPlusPath.getFraudplusPackagesForUser}/${userId}/${productId}`,
        {
          headers: setHeaders(),
        }
      )
      .then((response) => {
        return response
      })
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          return null
        }
        return error
      })
  },
  async fetchPackagesforUserOrder({ state }, { userId, productId } = {}) {
    return axios
      .get(
        `${appConfig.apiEndPoint}${endpoint.fraudPlusPath.getFraudplusPackagesForUserOrder}/${userId}/${productId}`,
        {
          headers: setHeaders(),
        }
      )
      .then((response) => {
        return response
      })
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          return null
        }
        return error
      })
  },
}
function setHeaders() {
  return {
    'Content-Type': 'application/json',
    Authorization: `Bearer ${store.state.auth.currentUser.access_token}`,
  }
}
function setDefaultAuthHeaders(state) {
  axios.defaults.headers.get['Pragma'] = 'no-cache'
  axios.defaults.headers.get['Cache-Control'] = 'no-cache, no-store'
  axios.defaults.headers.common.Authorization = state.currentUser
    ? state.currentUser.access_token
    : ''
}
